module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/issues/components/issue-main.component.html
// module id = ./src/app/modules/issues/components/issue-main.component.html
// module chunks = main